import * as React from "react";

interface State {
  hasError: boolean;
  error: Error | undefined;
}

export class FixtureScoreboardErrorBoundary extends React.Component<{}, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: undefined };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error: error });
  }

  render() {
    if (this.state.hasError) {
      return <div>(Could not load match details)</div>;
    }
    return this.props.children;
  }
}